import { render, staticRenderFns } from "./ConsentInsured.vue?vue&type=template&id=1f1cd5d6&"
import script from "./ConsentInsured.vue?vue&type=script&lang=js&"
export * from "./ConsentInsured.vue?vue&type=script&lang=js&"
import style0 from "./ConsentInsured.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports